var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreDefault28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 11.6667C5.71675 11.6667 4.66675 12.7167 4.66675 14C4.66675 15.2834 5.71675 16.3334 7.00008 16.3334C8.28341 16.3334 9.33341 15.2834 9.33341 14C9.33341 12.7167 8.28341 11.6667 7.00008 11.6667ZM21.0001 11.6667C19.7167 11.6667 18.6667 12.7167 18.6667 14C18.6667 15.2834 19.7167 16.3334 21.0001 16.3334C22.2834 16.3334 23.3334 15.2834 23.3334 14C23.3334 12.7167 22.2834 11.6667 21.0001 11.6667ZM14.0001 11.6667C12.7167 11.6667 11.6667 12.7167 11.6667 14C11.6667 15.2834 12.7167 16.3334 14.0001 16.3334C15.2834 16.3334 16.3334 15.2834 16.3334 14C16.3334 12.7167 15.2834 11.6667 14.0001 11.6667Z",
    fill: "#B7C2CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDefault28);
export default __webpack_public_path__ + "static/media/more_default_28.962cacab4d54a7c5ce614dc8f055dfdf.svg";
export { ForwardRef as ReactComponent };